import type {
  AppointmentPresence,
  AppointmentWorkItem,
} from "@/types/clinician";

const MINUTE_MS = 60_000;
const PRESENCE_LEAD_MS = 10 * MINUTE_MS;
const PRESENCE_TRAIL_MS = 30 * MINUTE_MS;

export function attendanceIsFinal(
  status:
    | AppointmentWorkItem["attendance_status"]
    | AppointmentPresence["attendance_status"]
    | null
    | undefined,
) {
  return status === "attended" || status === "no_show";
}

export function shouldMonitorAppointmentPresence(
  appointment: AppointmentWorkItem,
  now = new Date(),
) {
  if (attendanceIsFinal(appointment.attendance_status)) return false;
  if (/cancel|re-scheduled/i.test(appointment.status || "")) return false;
  const startsAt = Date.parse(appointment.starts_at);
  if (!Number.isFinite(startsAt)) return false;
  const parsedEnd = appointment.ends_at
    ? Date.parse(appointment.ends_at)
    : Number.NaN;
  const endsAt = Number.isFinite(parsedEnd)
    ? parsedEnd
    : startsAt + 30 * MINUTE_MS;
  const currentTime = now.getTime();
  return (
    currentTime >= startsAt - PRESENCE_LEAD_MS &&
    currentTime <= endsAt + PRESENCE_TRAIL_MS
  );
}
